module.exports = __webpack_public_path__ + "static/img/會員獨享300.8ddf6b0c.png";